import React, { useState, useEffect } from 'react';
import leaveService from '../services/leaveService';
import LeaveForm from '../components/leaves/LeaveForm';
import Modal from '../components/common/Modal';
import Table from '../components/common/Table';
import Badge from '../components/common/Badge';
import PageHeader from '../components/common/PageHeader';
import { formatDate } from '../utils/formatters';
import { useAuth } from '../hooks/useAuth';

export default function Leaves() {
  const [leaves, setLeaves] = useState([]);
  const [loading, setLoading] = useState(true);
  const [modal, setModal]   = useState(false);
  const { user } = useAuth();

  const load = async () => {
    setLoading(true);
    try {
      setLeaves(await leaveService.getAll());
    } catch {
      setLeaves([]);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => { load(); }, []);

  const columns = [
    { key: 'driver_name', label: 'Driver' },
    { key: 'start_date', label: 'From', render: (v) => formatDate(v) },
    { key: 'end_date', label: 'To', render: (v) => formatDate(v) },
    { key: 'days', label: 'Days' },
    { key: 'reason', label: 'Reason', render: (v) => v || '—' },
    { key: 'status', label: 'Status', render: (v) => <Badge status={v} label={v} /> },
  ];

  return (
    <div>
      <PageHeader title="Leave Management" subtitle="Driver leave requests"
        actions={user?.role === 'driver' ? <button className="btn btn-primary" onClick={() => setModal(true)}>+ Apply for Leave</button> : null}
      />
      <div className="card">
        <Table columns={columns} data={leaves} loading={loading} emptyMessage="No leave records" />
      </div>
      <Modal isOpen={modal} onClose={() => setModal(false)} title="Apply for Leave">
        <LeaveForm onCancel={() => setModal(false)} onSuccess={() => { setModal(false); load(); }} />
      </Modal>
    </div>
  );
}